import { useOrganizationContext } from '@apps/web/context/organization_provider';

/**
 * Get the organization id for the current user.
 */
export function useOrganizationId(): string | null {
    return useOrganizationContext().organizationId;
}
